import parsePhoneNumber from "libphonenumber-js";
import { getToken } from "../api/api_instance";
import { PAYMENT_URL } from "../constant/server";

export const buildPaymentPath = ({ user, paymentOption, currentOrder }) => {
  const token = getToken();
  const { email, phoneNumber } = user;

  const nationalPhone = `0${parsePhoneNumber(phoneNumber)?.nationalNumber}`;
  const { totalPrice, id } = currentOrder || {};

  return `${PAYMENT_URL}/client/api/v1/payment/checkout?amount=${totalPrice}&from_application=BOOKING&payment_option=${paymentOption}&token=${token}&phone_number=${nationalPhone}&order_id=${id}&customer_email=${email}&currency=SAR`;
};
